// 游戏模块API接口

import { BaseApi } from "../../../utils/request";
import { GameCategory, GameInfo, GameListParams } from "../types";
import { PaginatedResponse } from "../../../types/common";

// 游戏API
export class GameApi extends BaseApi {
  // 获取游戏分类
  async getGameCategories(): Promise<GameCategory[]> {
    const response = await this.get<GameCategory[]>(
      "/api/game/categories",
      {},
      {
        cache: true,
        cacheTime: 30 * 60 * 1000, // 30分钟缓存
        alert: false,
      }
    );
    return response.data;
  }

  // 获取热门游戏
  async getGames(limit: number = 10): Promise<GameInfo[]> {
    const response = await this.get<GameInfo[]>(
      `/api/game/hot?limit=${limit}`,
      {},
      {
        cache: true,
        cacheTime: 5 * 60 * 1000, // 5分钟缓存
        alert: false,
      }
    );
    return response.data;
  }

  // 获取游戏列表
  async getGameList(
    params: GameListParams
  ): Promise<PaginatedResponse<GameInfo>> {
    const response = await this.get<PaginatedResponse<GameInfo>>(
      "/api/game/list",
      params,
      {
        cache: true,
        cacheTime: 2 * 60 * 1000, // 2分钟缓存
        alert: false,
      }
    );
    return response.data;
  }

  // 搜索游戏
  async searchGames(keyword: string): Promise<GameInfo[]> {
    const response = await this.get<GameInfo[]>(
      "/api/game/search",
      { keyword },
      {
        cache: true,
        cacheTime: 1 * 60 * 1000, // 1分钟缓存
        alert: false,
      }
    );
    return response.data;
  }

  // 获取游戏详情
  async getGameDetail(gameId: string): Promise<GameInfo> {
    const response = await this.get<GameInfo>(
      `/api/game/detail/${gameId}`,
      {},
      {
        cache: true,
        cacheTime: 10 * 60 * 1000, // 10分钟缓存
        alert: false,
      }
    );
    return response.data;
  }

  // 收藏/取消收藏游戏
  async toggleFavorite(gameId: string): Promise<{ isFavorite: boolean }> {
    const response = await this.post<{ isFavorite: boolean }>(
      `/api/game/favorite/${gameId}`
    );
    return response.data;
  }
}

// 创建API实例
export const gameApi = new GameApi();
